import { LossDriversPage } from "@/components/investigations/LossDriversPage";
import { createFileRoute } from "@tanstack/react-router";

export interface LossDriverSearch {
  /**
   * The plan; the analysis written from the findings once the plan is saved; or the
   * countermeasures recorded against it once the analysis is saved.
   */
  stage?: "plan" | "analysis" | "countermeasures";
  /** The countermeasure open in the side panel. */
  cm?: string;
}
export const Route = createFileRoute(
  "/_authenticated/loss-drivers/$investigationId",
)({
  validateSearch: (search: Record<string, unknown>): LossDriverSearch => ({
    stage:
      search.stage === "plan" ||
      search.stage === "analysis" ||
      search.stage === "countermeasures"
        ? search.stage
        : undefined,
    cm:
      typeof search.cm === "string" && /^[0-9a-f-]{36}$/.test(search.cm)
        ? search.cm
        : undefined,
  }),
  component: Page,
});
function Page() {
  const { investigationId } = Route.useParams();
  const { stage, cm } = Route.useSearch();
  return <LossDriversPage id={investigationId} stage={stage} open={cm} />;
}
